<template>
	<c-dialog ref="dialog" height="400" width="600" @resolve="editHandle">
		<c-form ref="form" unit-width="100%">
      <c-input type="hidden" name="id"></c-input>
      <c-form-item label="分类" required tip="请选择系列关联分类，仅单线选">
        <c-select name="category_id" v-model="categoryId" async @search="searchCategory" :value-data="selectedCategory"></c-select>
      </c-form-item>
      <c-form-item label="品牌" required :tip="categoryId?'请选择系列系列，仅单线选':'请先选择分类后再选择系列'">
        <c-select name="brand_id" v-model="brandId" async @search="searchBrand" :value-data="selectedBrand" :disabled="!categoryId"></c-select>
      </c-form-item>
      <c-form-item label="系列名称" required tip="系列名称不允许重复">
				<c-input name="series_name" maxlength="20"></c-input>
			</c-form-item>
			<c-form-item label="备注">
        <c-input type="textarea" name="remark"></c-input>
			</c-form-item>
    </c-form>
	</c-dialog>
</template>

<script>
import {mapState} from 'vuex'
export default {
	computed: {
	},
	
	data() {
		return {
			  editState: false,
        selectedCategory:[], //已选中的分类
        categoryId:0,        //已选中的分类ID
        selectedBrand:[],    //已选中的品牌
        brandId:0            //已选中的品牌ID
    }
	},
  watch: {
    //选择的分类变化，清除已选品牌
    categoryId() {
      if (this.categoryId && this.brandId){
          this.selectedBrand = [];
      }
    }
  },

	methods: {
    /*******搜索分类*****************/
    searchCategory(keyword, resolve){
      this.request({
        url:'/spu/category/options',
        data: {
          keyword: keyword
        },
        success:data => {
          resolve(data);
        }
      })
    },
    /*******搜索品牌****************/
    searchBrand(keyword, resolve){
      this.request({
        url:'/spu/brand/options',
        data: {
          category_id:this.categoryId,
          keyword: keyword
        },
        success:data => {
          resolve(data);
        }
      })
    },
    /*******查询系列详情*****************/
    getDetail(id){
      this.request({
        url:'/spu/series/detail',
        data: {
          id: id
        },
        success:data => {
          if (data){
            //已选中的[分类]
            this.selectedCategory = [{
              name: data.category_name,
              value:data.category_id
            }];
            //已选中的[分类]Id
            this.categoryId = data.category_id;
            //已选中的品牌
            this.selectedBrand = [{
              name: data.brand_name,
              value:data.brand_id
            }];
          }
        }
      });
    },
		/*********打开编辑框，初始化**********/
		open(data) {
			this.editState = !!data;
			this.$refs.form.clear();
			if (data) {
				this.getDetail(data.id);
				this.$refs.form.set(data);
			}
			//填充form表单
			this.$refs.dialog.open({
				title: data ? '编辑系列' : '添加系列'
			});
		},

		/*******添加、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: this.editState?'/spu/series/edit':'/spu/series/add',
				rule: {
          category_id: '请选择系列关联的分类',
          brand_id: '请选择系列关联的品牌',
          series_name: '请输入系列名称'
				},
				dataFormatter: data => {
					return data;
				},
				success: (data, res) => {
					next();
					if(this.editState){
						this.$message({
							message: '编辑成功',  // 提示内容,
							type: 'success'
						});
					}else{
            this.$message({
              message: '添加成功',  // 提示内容,
              type: 'success'
            });
					}
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>